import { CandidateService } from './../../_services/candidate.service';
import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter,ElementRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateActionService } from 'src/app/_services/candidate-action.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { GlobalService } from 'src/app/_services/global.service';
import { UntypedFormControl, Validators } from '@angular/forms';
declare const clevertap;
import {LoginService}  from '../../_services/login.service'
import * as __ from 'lodash';
import * as _ from 'underscore';
import { environment } from "../../../environments/environment";
@Component({
    selector: 'app-candidate-note',
    templateUrl: './candidate-note.component.html',
    styleUrls: ['./candidate-note.component.scss'],
    standalone: false
})
export class CandidateNoteComponent implements OnInit {

  notesdata: string;
  notesControl: UntypedFormControl = new UntypedFormControl(null, Validators.required);
  recentlyaddednotes: any[] = [];
  notesErrorMessage: any;
  NotesCounts: any;
  noteid: string;
  oldnote: string;
  candidateNumber: any;
  talentvalue: string = null;
  pipeline_list = GlobalService.PipelineStatus;

  notesUsers: any[]=[];
  notesSelectedUser: any[]=[];
  notePrivacy :  any = "Visible to everyone";
  shownote: any = "Visible to everyone"
  userid : string = ''
  isprivate : any ;
  successMessage : string = ''
  userfname : string = ''
  userlname : string = ''
  errorMessage: string

  @ViewChild('openVisibilityModel') openVisibilityModel: TemplateRef<any>;
  @ViewChild('notesElem', { static: false }) notesElem: ElementRef<any>;

  notes: UntypedFormControl = new UntypedFormControl(null, Validators.required)
  actualMentionUserList: any[] = [];
  allMentionList: [] = [];
  sendMentionBufferedArray: any[] = [] // to hold if note private is checked
  sendMentionEmailArray: any[] = []
  isMentionUserActive: boolean = false;
  disableCheckboxForUser : boolean = false;
  modalref : any

  @ViewChild('errorModal') errorModal: TemplateRef<any>
  @ViewChild('successModal') successModal: TemplateRef<any>
  @Input() noteforCandidate: any;
  @Input() BuldnoteforCandidate: any[];
  @Input() editnoteid : any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  existingNote : any [] =[]
  talentErrorMessage: string;
  selectedCandidates : any [] =[]
  candidateList : any [] = []
  addNoteSpinner : boolean = false;

editorModules = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline'],
      [{ list: 'bullet' }],
      ['link', 'clean']
    ]
  },
  mention: {
    allowedChars: /^[A-Za-z\s]*$/,
    mentionDenotationChars: ['@'],
    source: (searchTerm: string, renderList: Function) => {
      this.loginService.getTagUsers(searchTerm).subscribe((res: any) => {
        if (res.status === 'success') {
          this.actualMentionUserList = res.message.slice();
          const mentionList = res.message
            .filter((v: any) => v)
            .map((value: any) => ({
              ...value,
              id: value.userid,
              value: value.firstname + ' ' + value.lastname
            }));
          renderList(mentionList, searchTerm);
        }
      });
    },
    onSelect: (item: any, insertItem: Function) => {
      const userObject = this.actualMentionUserList
        .find((x: any) => x.userid === parseInt(item.id)) || null;
      userObject ? this.openSearch(userObject) : null;
      insertItem(item);
    }
  }
};


  constructor(public modalService: NgbModal, public candidateaction: CandidateActionService,
    private _localstorageservice: LocalStorageService, public _candidateservice: CandidateService,
    private loginService : LoginService, private activemodal: NgbActiveModal) { }

  ngOnInit() {
    this.userid = this._localstorageservice.getItem('userid');
    this.userfname = this._localstorageservice.getItem('ufname')
    this.userlname = this._localstorageservice.getItem('ulname')
    if(this.BuldnoteforCandidate && this.BuldnoteforCandidate.length){

      this.BuldnoteforCandidate.map((candidate)=>{

        const singlecandidate = {}
        singlecandidate['firstname'] = candidate.basicdetails.firstname
        singlecandidate['lastname'] = candidate.basicdetails.lastname
        this.candidateList.push(singlecandidate)
      })
    }
    if (this.noteforCandidate) {
      let data = {
        start: 0,
        candidatenumber: this.noteforCandidate.candidatenumber
      }
      this.candidateNumber = this.noteforCandidate.candidatenumber
      this.candidateaction.getCandidateNotes(data).subscribe((res: any) => {
        if (res.status == 'success') {

          this.recentlyaddednotes = res.message.getnotes,
            this.NotesCounts = res.message.getNotesCounts
            this.existingNote = this.recentlyaddednotes.filter((note)=>note.candidatenoteid == this.editnoteid)

            if(this.existingNote && this.existingNote.length){
              this.noteid = this.existingNote.length ? this.editnoteid : null
              this.oldnote = this.existingNote[0].note
              this.notes.setValue(this.existingNote[0].note);
              if(this.existingNote[0].isprivate == 0){
                this.notePrivacy = 'Visible to everyone'
                this.shownote = 'Visible to everyone'
              }else if (this.existingNote[0].isprivate == 2){
                this.notePrivacy = 'Visible to selected users'
                this.shownote = 'Visible to selected users'
              }else if(this.existingNote[0].isprivate == 1){
                this.notePrivacy = 'Visible only to me'
                this.shownote = 'Visible only to me'
              }else{
                this.notePrivacy = 'Visible to everyone'
                this.shownote = 'Visible to everyone'
              }
              this.candidateaction.getRestrictedUsersOfNote(this.editnoteid).subscribe((res: any) => {
                if(res.status == 'success'){
                  if(res?.message?.length){
                   this.notesSelectedUser = res.message
                  }
                }

              })
            }
        }
      })
    }
    this.notesControl.valueChanges.subscribe(res => {
      let scriptRegex = /&lt;script(.*)&gt;/g;
      let scriptRegex1 = /<script(.*)>/g;
      let htmltagscript = /<(.|\n)*?>/
      if (res && (scriptRegex.test(res.trim()) == true || scriptRegex1.test(res.trim()) == true || res.includes('src=') || htmltagscript.test(res.trim()) == true)) {
        this.notesControl.setValue(null)
        this.notesControl.setErrors({ 'htmlPresent': true })
      } else {
        this.notesControl.setErrors(null)
      }
    })
  }


// Simplify editorOnInit — no more new Mention()
editorOnInit(event: any) {
  // Only use this for other editor customizations if needed
  const quillInstance = event.editor;
}
  saveCandidateNote() {
    let notesObj = {}
    this.notesdata = this.notes.value || '';
    this.validateAllFormFields(this.notes);
    const noteLength = this.notesdata.replace(/<\/?p>/g, '').trim().length;
    if (this.notes.valid && this.notesdata != null && this.notesdata != '' && noteLength) {
      if (GlobalService.hasEncodedHTML(this.notesdata)) {
        this.notes.setErrors({
          htmlPresent: true
        });
        return;
      }
      if(this.notePrivacy == 'Visible to everyone'){
        this.isprivate = 0
      }else if (this.notePrivacy == 'Visible to selected users'){
        this.isprivate = 2
      }else if(this.notePrivacy == 'Visible only to me'){
        this.isprivate = 1
      }
      if (this.noteid) {
        this.addNoteSpinner = true;
        notesObj = {
          "editdetails": {
            "note": this.notesdata.replace(/'/g, "''"),
            "updatedby": this._localstorageservice.getItem('userid'),
            "notetype": "note" ,
            "isprivate" : this.isprivate
          },
          "restricteduserids": this.notesSelectedUser && this.isprivate == 2 ? this.notesSelectedUser.filter(x => x.teamid != null).map(x => x.userid) : [],
          "noteid": this.noteid,
          "candidatenumber": this.candidateNumber,
          "activitylog": {
            "action": "update",
            "type": "note",
            "tablename": "candidatenotes",
            "primarykeyid": this.noteid,
            "updatedfieldname": "notes",
            "userid": this._localstorageservice.getItem('userid'),
            "createdby": this._localstorageservice.getItem('userid'),
            "oldvalue": this.oldnote.replace(/'/g, "''"),
            "newvalue": this.notesdata.replace(/'/g, "''")
          }
        }
        this.candidateaction.editCandidateNote(notesObj).subscribe((res: any) => {
          if (res.status == "success") {
            this.modalService.dismissAll();
            this.passEntry.emit('updated')
            this.notesSelectedUser = []
            this.notePrivacy = "Visible to everyone";
            this.notes.setValue(null);
            //- Clevertap Add notes event
            let ctObj = {
              "Name": this.noteforCandidate.firstname + " " + this.noteforCandidate.lastname,
              "Job title": this.noteforCandidate.jobtitle,
              "Company Name": this.noteforCandidate.companyname,
              "Source": this.noteforCandidate.source,
              "Location": this.noteforCandidate.locationname
            }
            this.cleverTapEvent("Notes", ctObj);
          }
          else {
            this.modalService.dismissAll();
            this.passEntry.emit('error')

          }
        },(err) => { }, () => {
          this.addNoteSpinner = false;
          if(this.isprivate == 0) this.sendMentionEmails(this.notesdata, this.sendMentionEmailArray);
        })

      }
      else {
        this.addNoteSpinner = true;
        //for single candidate
        if (this.noteforCandidate) {
          notesObj = {
            notes: [{
              note: {
                candidatenumber: "" + this.noteforCandidate.candidatenumber + "",
                createdby: this._localstorageservice.getItem('userid'),
                note: "" + this.notesdata + "",
                notetype: "note" ,
                isprivate: this.isprivate
              },
              restricteduserids: this.notesSelectedUser && this.isprivate == 2 ? this.notesSelectedUser.filter(x => x.teamid != null).map(x => x.userid) : [],
              activitylog: {
                userid: this._localstorageservice.getItem('userid'),
                action: "create",
                tablename: "candidatenote",
              }
            }]
          }
        } else {
          //for bulk candidate
          let notes = [];
            notes.push({
              note: {
                candidatenumber: "" + this.noteforCandidate.candidatenumber + "",
                createdby: this._localstorageservice.getItem('userid'),
                note: "" + this.notesdata + "",
                notetype: "note" ,
                isprivate: this.isprivate
              },
              restricteduserids: this.notesSelectedUser && this.isprivate == 2 ? this.notesSelectedUser.filter(x => x.role != "admin").map(x => x.userid) : [],
              activitylog: {
                userid: this._localstorageservice.getItem('userid'),
                action: "create",
                tablename: "candidatenote",
              }
            })



          notesObj = {
            notes: notes
          }
        }
        this.candidateaction.AddCandidateNote(notesObj).subscribe((res: any) => {
          if (res.status == 'success') {

            if (this.noteforCandidate) {
              this.passEntry.emit('noteAdded')
              this.modalService.dismissAll()

              // this.successMessage = 'Notes Added succesfully';
              // setTimeout(() => this.successMessage = '', 5000);
              this.notesSelectedUser = []
              this.notePrivacy = "Visible to everyone";
              this.notes.setValue(null);
             // const dialogRef = this.modalService.open(this.successModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
              //- Clevertap Add notes event
              let ctObj = {
                "Name": this.noteforCandidate.firstname + " " + this.noteforCandidate.lastname,
                "Job title": this.noteforCandidate.jobtitle,
                "Company Name": this.noteforCandidate.companyname,
                "Source": this.noteforCandidate.source,
                "Location": this.noteforCandidate.locationname
              }
              this.cleverTapEvent("Notes", ctObj);
            } else {
              this.passEntry.emit('noteAdded')

              this.modalService.dismissAll()
              //- Clevertap Add bulk notes event
              let ctObj = {
                "No. of candidates": this.BuldnoteforCandidate.length,
                "Note": this.notesdata.replace(/'/g, "''"),
              }
              this.cleverTapEvent("Bulk Notes", ctObj);
            }
          }
          else {
            this.modalService.dismissAll()
            this.passEntry.emit('error')
          }
        },(err) => { }, () => {
          this.addNoteSpinner = false;
          if(this.isprivate == 0) this.sendMentionEmails(this.notesdata, this.sendMentionEmailArray);
        })
      }
    }

    else {
      this.notesErrorMessage = "Note is Required"
      !noteLength && this.notes.setErrors({ 'required': true });
    }

  }

  dismiss() {
    this.modalService.dismissAll();
  }

  SaveTalent() {
    if (this.talentvalue != null) {
      let data = {
        "candidatenumber": this.noteforCandidate.candidatenumber,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "pipelinestatus": this.talentvalue,
        "activitylog": [
          {
            "action": "'update'",
            "tablename": "'candidate'",
            "type": "'pipeline status'",
            "updatedfieldname": "'pipelinestatus'",
            "oldvalue": "'" + this.noteforCandidate.pipelinestatus + "'",
            "newvalue": "'" + this.talentvalue + "'"
          }
        ]
      }
      this._candidateservice.updatepipelineStatus(data).subscribe((res: any) => {
        if (res.status == "success") {
          this.modalService.dismissAll();
          this._candidateservice.createCandidateData();
          this.passEntry.emit('noteAdded')
        }
        else {
          this.modalService.dismissAll();
          this.passEntry.emit('error')

        }
      })
    }
    else {
      this.talentErrorMessage = 'Please Select Talent Status'
    }
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  changeNotePrivacy(data){
      this.notePrivacy = data

  //  document.getElementsByClassName('asd')[0].classList.remove("show")
    if(data == 'Visible to selected users' ){
      this.getNotesUsers()
      this.modalref = this.modalService.open(this.openVisibilityModel, { windowClass: 'myModalClass', centered: true, backdrop: 'static', keyboard: false });
    }

  }

  getNotesUsers(){
    let searchTerm = ''
    this.notesUsers = []
    this.loginService.getTagUsers(searchTerm).subscribe((res: any) => {
      if(res.status == 'success'){
          res.message && res.message.map((user)=>{
              if((user && user.teamid == null)) {
                 user.disableCheckbox = true
                 this.notesSelectedUser.push(user)

              }
              this.notesUsers.push(user)
              if(this._localstorageservice.getItem('role') != 'team admin') {
                this.notesUsers = _.reject(this.notesUsers, {userid: this._localstorageservice.getItem('userid')})

              }

            })
      }
    })

  }

  returnIsChecked(data){
    let isSelected = this.notesSelectedUser.filter(x => x.userid == data.userid)
    if(isSelected && isSelected.length){
      return true
    }
  }

  selectTeamMember(e,member){
    if(e.target.checked){
      this.notesSelectedUser.push(member)
    }else{
      this.notesSelectedUser = this.notesSelectedUser.filter(x => x.userid != member.userid)
    }
  }

  returnCheckedValue(data){
    if(data == this.shownote){
      return true
    }
  }

  openSearch(event) {
    this.sendMentionEmailArray.push(event)
    // this.isMentionUserActive = false;
    // this.allMentionList = []
  }

  close(){
    //this.shownote = ''
    this.modalref.close()
  }


  sendMentionEmails(completeText, mentionedUsersList) {
    let template;
    let verifiedUsers = [];
    mentionedUsersList = _.uniq(mentionedUsersList, 'userid');
    mentionedUsersList = mentionedUsersList.filter(user => user.userid != this.userid)
    if(mentionedUsersList && mentionedUsersList.length && this.candidateList.length == 0) {
      mentionedUsersList.map(user => {
        if(completeText.includes(user.firstname) && user.userid != this.userid) {
          template = `Hi ${user.firstname}<br />${this.userfname} ${this.userlname} mentioned you in the following Note on the candidate ${this.noteforCandidate ? this.noteforCandidate.firstname + this.noteforCandidate.lastname : ''} - <br/>
          <strong>${completeText}</strong>
          <a href="${environment.frontendurl}/my-candidates?search=${this.noteforCandidate ? this.noteforCandidate.firstname + ' ' + this.noteforCandidate.lastname : ''}" target="_blank">Click to Respond</a><br />Thanks,<br />Team Webbtree`;
          user['emailHtmlContent'] = template;
          user['subject'] = `Webbtree | ${this.userfname} ${this.userlname} mentioned you in a Note on the candidate ${this.noteforCandidate ? this.noteforCandidate.firstname + this.noteforCandidate.lastname : ''}`;
          verifiedUsers.push(user)
        }
      })
    }

    if(mentionedUsersList && mentionedUsersList.length && this.candidateList.length) {
      mentionedUsersList.map(user => {
        if(completeText.includes(user.firstname) && user.userid != this.userid) {
          this.candidateList.map((candidate)=>{
            template = `Hi ${user.firstname}<br />${this.userfname} ${this.userlname} mentioned you in the following Note on the candidate ${ candidate.firstname ? candidate.firstname : ''} ${ candidate.lastname ? candidate.lastname : ''} - <br/>
            <strong>${completeText}</strong>
            <br />Thanks,<br/>Team Webbtree`;
            user['emailHtmlContent'] = template;
            user['subject'] = `Webbtree | ${this.userfname} ${this.userlname} mentioned you in a Note on the candidate ${ candidate.firstname ? candidate.firstname : ''} ${ candidate.lastname ? candidate.lastname : ''} `;
            verifiedUsers.push(user)
          })

        }
      })
    }
    this.loginService.sendMentionedEmail({ 'users': verifiedUsers }).subscribe((res: any) => {
      this.sendMentionBufferedArray = []
      this.sendMentionEmailArray = []
    })
    this.notes.reset();
    this.isprivate = false;
    // this.isnotesedited = false;
    // this.noteid = 0;
    this.oldnote = "";
  }

  validateAllFormFields(formControl: UntypedFormControl) {
    // Mark the control as touched
    formControl.markAsTouched({ onlySelf: true });
  }
}
